
import React, { PropsWithChildren, useEffect, useState } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';

import './Topics.css';
import { PathUtils } from '@adobe/aem-spa-page-model-manager';
import { Row, Col, Section } from '../../importCL';
import Button from '../../component-library/atoms/Button/Button';


interface ITopicsProps extends MappedComponentProperties {
  topics?: string[];
  extension?: string;
  fromTheFeed?: boolean;

}

export const TopicsEditConfig = {
    emptyLabel: 'Topics',
    isEmpty: (props: PropsWithChildren<ITopicsProps>) => {
        return !props || !props.topics?.length;
    },
};


const Topics = (props: PropsWithChildren<ITopicsProps>): JSX.Element => {
    const path = props.extension ? '/content/cob-corp-acquisition/us/en/articles/topics/' : '/articles/topics/';
    const [topics, setTopics] = useState<string[]>([]);

    useEffect(() => {
        const articleMetadata = PathUtils.getMetaPropertyValue('articleFeedData');
        if (props.fromTheFeed) {
            if (articleMetadata !== null) {
                const parsedMetadata = JSON.parse(articleMetadata);
                setTopics(parsedMetadata.articlesTopics);
            }
        } else {
            setTopics(props.topics || []);
        }
    }, []);

    const getTopics = () => {
        return topics && topics.map((topic, index) => {
            const displayTopic = topic.split(' ').map((word : string) => {
                return word.charAt(0).toUpperCase() + word.slice(1);
            }).join(' ');
            return (
                <Button
                    key={index}
                    variant='chip'
                    size='medium'
                    href={`${path}${topic.replace(/\s/g, '-')}${props.extension}`}
                    className='mr-6'
                    >
                    {displayTopic}
                </Button>
            )
        });
    };

    return (
        topics && topics.length > 0 ?
            <Section id='topics' className='!p-0'>
                <Row className='Topics__row'>
                    <Col className='Topics__col mb-4'>
                        Topics: {getTopics()}
                    </Col>
                </Row>
            </Section>
            :
            <></>
           
    );
};

export default Topics;
